import endpoint from 'config/endpoint'
import { fetch } from 'utils/fetch'
import { getCheckoutComPublicKey, isProd } from 'utils/isomorphicEnvironment'

const getPaymentsEndpoint = () => `${endpoint('payments')}/payments/`

const HEADERS = {
  'Content-Type': 'application/json',
}

function authPayment(reqData, sessionId) {
  return fetch(
    null,
    `${getPaymentsEndpoint()}payment-auth?session_id=${sessionId}`,
    reqData,
    'POST',
    undefined,
    HEADERS,
  )
}

function checkPayment(checkoutSessionId, goustoSessionId) {
  return fetch(
    null,
    `${getPaymentsEndpoint()}payments/${checkoutSessionId}?session_id=${goustoSessionId}`,
    null,
    'GET',
    undefined,
    HEADERS,
  )
}

function fetchPayPalToken() {
  const params = { provider: 'paypal' }

  return fetch(null, `${getPaymentsEndpoint()}token`, params, 'GET', undefined, HEADERS)
}

function signupPayment(reqData, provider, sessionId) {
  return fetch(
    null,
    `${getPaymentsEndpoint()}signup-payments?provider=${provider}&session_id=${sessionId}`,
    reqData,
    'POST',
    undefined,
    HEADERS,
  )
}

function get3DSCompliantToken(goustoRef) {
  return fetch(
    null,
    `${getPaymentsEndpoint()}3ds-compliant/${goustoRef}`,
    {},
    'GET',
    undefined,
    HEADERS,
  )
}

function validateApplePaySession(validationURL) {
  return fetch(
    null,
    `${getPaymentsEndpoint()}validate-merchant-session?provider=applepay`,
    {
      apple_url: validationURL,
      display_name: 'Gousto payment',
    },
    'POST',
    undefined,
    HEADERS,
  )
}

/**
 * Converts Apple Pay token to checkout card token.
 */
function convertApplePayTokenToCheckoutToken(token) {
  const CHECKOUT_TOKENS_URL = `https://api.${isProd() ? '' : 'sandbox.'}checkout.com/tokens`

  return fetch(
    null,
    CHECKOUT_TOKENS_URL,
    {
      type: 'applepay',
      token_data: token,
    },
    'POST',
    undefined,
    {
      ...HEADERS,
      Authorization: getCheckoutComPublicKey(),
    },
  )
}

export {
  authPayment,
  checkPayment,
  fetchPayPalToken,
  signupPayment,
  get3DSCompliantToken,
  validateApplePaySession,
  convertApplePayTokenToCheckoutToken,
}
